/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface TextEditorAPI
 * @hideconstructor
 * @classdesc TextEditor feature
 * @example dashboard.getFeature('TextEditor')
 */
define([], function () {

	class TextEditorAPI {
		/**
		 * @returns {Array} An array of all custom colors a widget title editor is using
		 */
		getCustomColorList() { }

		/**
		 * @param {Object} title which has the following structure
		 * @param {String} title.widgetId the widget which the title belongs to
		 * @param {TextEditor} title.textEditor The TextEditor instance for the widget's title
		 * @param {String} title.titleId
		 */
		registerProvider() { }
	}

	return TextEditorAPI;
});
